import script from "./MainFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainFilter.vue?vue&type=script&setup=true&lang=ts"

import "./MainFilter.vue?vue&type=style&index=0&id=2b0cefd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0cefd2"]])

export default __exports__